import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { getTranslationProvider } from '../core/i18n/getTranslationProvider';
import { TranslatableComponent } from '../core/i18n/TranslatableComponent';
import { BlFrontendButtonComponent } from '../core/wrappers/bl-frontend-button.component';
import { AuthActions } from '../core/state/auth/auth.actions';

@Component({
  imports: [RouterLink, TranslocoModule, BlFrontendButtonComponent],
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <main class="min-h-screen bg-blg-grey-50 px-4 py-8 sm:px-6 lg:px-8">
        <div class="mx-auto flex min-h-[calc(100vh-4rem)] max-w-3xl items-center">
          <section
            aria-labelledby="missing-account-link-title"
            class="w-full rounded-lg border border-bl-grey-200 bg-white p-6 shadow-sm sm:p-10">
            <p
              class="mb-5 inline-flex rounded-full bg-bl-grey-50 px-3 py-1 text-sm font-semibold text-bl-blue-light-600">
              {{ t('status') }}
            </p>

            <h1 id="missing-account-link-title" class="text-headline mb-4 font-bold text-bl-grey-700">
              {{ t('title') }}
            </h1>
            <p class="text-sub-headline mb-8 text-bl-grey-700">
              {{ t('description') }}
            </p>

            <div class="mb-8 border-t border-bl-grey-200 pt-6">
              <h2 class="mb-2 text-lg font-semibold text-bl-grey-700">{{ t('blkontoTitle') }}</h2>
              <p class="mb-5 text-description text-bl-grey-600">{{ t('blkontoDescription') }}</p>
              <bl-frontend-button text="Logga in på ditt BL Konto" (onclick)="loginToBlAccount()"></bl-frontend-button>
            </div>

            <div class="border-t border-bl-grey-200 pt-6">
              <h2 class="mb-2 text-lg font-semibold text-bl-grey-700">{{ t('noBlkontoTitle') }}</h2>
              <p class="mb-3 text-description text-bl-grey-600">{{ t('noBlkontoDescription') }}</p>
              <a routerLink="/missingfirms" class="font-semibold text-bl-blue-light-600 hover:underline">
                {{ t('contactLink') }}
              </a>
            </div>
          </section>
        </div>
      </main>
    </ng-container>
  `,
  styles: `
    :host {
      display: block;
      min-height: 100%;
    }
  `,
  providers: [getTranslationProvider('MissingAccountLinkComponent')],
  standalone: true,
})
export class MissingAccountLinkComponent extends TranslatableComponent {
  loginToBlAccount() {
    this.store.dispatch(AuthActions.initSsoLogin({ useBlAccountAuthenticator: true }));
  }
}
